import { Loader, Button, Group } from "@mantine/core"
import {
  IconRotateClockwise2,
  IconDeviceFloppy,
  IconCheck,
} from "@tabler/icons-react"
import { Link } from "react-router-dom"

import { BudgetsResponses } from "@costory/types/endpoints/budgets"
import { BudgetStatus } from "@costory/types/prisma-client"

import { BudgetTableMode } from "@costory/front/pages/Budgets/consts"

export const BudgetSaveEditToolbar = ({
  mode,
  isFormPending,
  lastVersion,
  handleClickSave,
  handleClickCreate,
  handleClickCreateRevision,
}: {
  mode: BudgetTableMode
  isFormPending: boolean
  lastVersion: BudgetsResponses.BudgetDetail | undefined
  handleClickSave: (status: BudgetStatus) => void
  handleClickCreate: (status: BudgetStatus) => void
  handleClickCreateRevision: (status: BudgetStatus) => void
}) => {
  if (isFormPending) {
    return (
      <Group justify="flex-end">
        <Loader mr={80} />
      </Group>
    )
  }
  if (mode == BudgetTableMode.View) {
    return <></>
  }
  if (mode === BudgetTableMode.Edit) {
    return (
      <>
        <>
          {lastVersion?.status === BudgetStatus.VALIDATED ? (
            <Group justify="flex-end">
              <Button
                component={Link}
                to="../new"
                leftSection={<IconRotateClockwise2 />}
                variant="outline"
              >
                New revision
              </Button>
              <Button
                onClick={() => handleClickSave(BudgetStatus.VALIDATED)}
                leftSection={<IconDeviceFloppy />}
                data-intercom-target="costory-tour-budget-save-validate-1"
              >
                Save changes
              </Button>
            </Group>
          ) : (
            <Group justify="flex-end">
              <Button
                onClick={() => handleClickSave(BudgetStatus.DRAFT)}
                leftSection={<IconDeviceFloppy />}
                variant="outline"
                data-intercom-target="costory-tour-budget-save-draft-1"
              >
                Save as draft
              </Button>
              <Button
                onClick={() => handleClickSave(BudgetStatus.VALIDATED)}
                leftSection={<IconCheck />}
                data-intercom-target="costory-tour-budget-save-validate-2"
              >
                Save and validate
              </Button>
            </Group>
          )}
        </>
      </>
    )
  }
  if (mode === BudgetTableMode.Revision) {
    return (
      <Group justify="flex-end">
        <Button
          onClick={() => handleClickCreateRevision(BudgetStatus.DRAFT)}
          leftSection={<IconDeviceFloppy />}
          variant="outline"
        >
          Create draft revision
        </Button>
        <Button
          onClick={() => handleClickCreateRevision(BudgetStatus.VALIDATED)}
          leftSection={<IconCheck />}
        >
          Create revision
        </Button>
      </Group>
    )
  }
  return (
    <Group justify="flex-end">
      <Button
        onClick={() => handleClickCreate(BudgetStatus.DRAFT)}
        variant="outline"
        data-intercom-target="costory-tour-budget-save-draft-2"
      >
        Save as draft
      </Button>
      <Button
        onClick={() => handleClickCreate(BudgetStatus.VALIDATED)}
        data-intercom-target="costory-tour-budget-create-button"
      >
        Create budget
      </Button>
    </Group>
  )
}
